// extracted by mini-css-extract-plugin
export default {"cls1":"Menu-cls1_Ifb","cls2":"Menu-cls2_v8i Menu-cls1_Ifb"};